import React from "react";
import styles from "./ivasErrors.module.css";

const IvasError = ({ errors }) => {
  return (
    <div className={styles.error_container}>
      {errors.map((error) => (
        <div>
          <div className={styles.header}>
            <h3>IVAS ERRORS</h3>
          </div>
          <div>
            <span>
              <b>Error name: </b> {error.name}
            </span>
          </div>
          <br className={styles.line_break} />
          <div>
            <span>
              <b>Error message: </b> {error.message}
            </span>
          </div>
          <br className={styles.line_break} />
          <div>
            <span>
              <b>Error stack: </b> {error.stack}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default IvasError;
